import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Container, Row, Col, Card } from 'react-bootstrap';

const CheckYourEmail = () => {
    return (
        <>
        <Helmet>
          <meta name="robots" content="noindex, nofollow" />
          <title>Check Your Email - Elliot Koss</title>
        </Helmet>
        <Container style={{ paddingTop: '100px', paddingBottom: '100px', minHeight: '100vh' }}>
            <Row className="justify-content-center">
                <Col xs={12} md={8} lg={6}>
                    <Card className="text-center" style={{ 
                        border: 'none', 
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                        borderRadius: '12px'
                    }}>
                        <Card.Body style={{ padding: '3rem 2rem 4rem 2rem' }}>
                            {/* Main Heading */}
                            <h1 style={{ 
                                fontSize: '2rem', 
                                fontWeight: '600', 
                                marginBottom: '1rem',
                                color: '#333'
                            }}>
                                Check Your Email
                            </h1>
                            
                            {/* Instructions */}
                            <p style={{ 
                                fontSize: '1.1rem', 
                                color: '#666', 
                                marginBottom: '1rem',
                                lineHeight: '1.6'
                            }}>
                                We've sent you a magic link to sign in. Please check your email and click the link to continue.
                            </p>
                            
                            {/* Email Address Info */}
                            <p style={{ 
                                fontSize: '1.1rem', 
                                color: '#666', 
                                marginBottom: '2rem',
                                lineHeight: '1.6'
                            }}>
                                Look for an email from: <span style={{ 
                                    color: '#067100',
                                    fontFamily: 'monospace',
                                    fontWeight: '500'
                                }}>
                                    elliot@newsletter.elliotkoss.com
                                </span>
                            </p>
                            
                            {/* Additional Instructions */}
                            <div style={{ textAlign: 'left', marginBottom: '2rem' }}>
                                <h5 style={{ fontSize: '1.1rem', fontWeight: '600', marginBottom: '0.5rem', color: '#333' }}>
                                    What to do next:
                                </h5>
                                <ul style={{ 
                                    fontSize: '1.1rem', 
                                    color: '#666', 
                                    paddingLeft: '1.5rem',
                                    margin: '0'
                                }}>
                                    <li>Check your inbox (and spam folder)</li>
                                    <li>Click the magic link in the email</li>
                                    <li>You'll be automatically signed in</li>
                                </ul>
                            </div>
                            
                            {/* Troubleshooting */}
                            <div style={{ 
                                backgroundColor: '#fff3cd', 
                                border: '1px solid #ffeaa7', 
                                borderRadius: '8px',
                                padding: '1rem',
                                marginBottom: '2rem'
                            }}>
                                <p style={{ 
                                    margin: '0', 
                                    fontSize: '1.1rem', 
                                    color: '#856404'
                                }}>
                                    <strong>Didn't receive the email?</strong> Check your spam folder or try again in a few minutes.
                                </p>
                            </div>
                            
                            {/* Back to Login */}
                            <div>
                                <a 
                                    href="/login" 
                                    style={{ 
                                        color: '#067100', 
                                        textDecoration: 'none',
                                        fontSize: '1.1rem'
                                    }}
                                >
                                    ← Back to Login
                                </a>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
        </>
    );
};

export default CheckYourEmail;
